var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.875 4.95834L6.375 13.4583L2.47916 9.56251L3.47791\n      8.56376L6.375 11.4538L13.8762 3.95959L14.875 4.95834Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }